export const convertDateTime = (date) => {
  if (!date) {
    return "";
  }
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  if (year === 1) return "";
  // return `${year}-${month}-${day}`;
  return `${day}/${month}/${year}`;
};
export const convertDateToTime = (date) => {
  if (!date) {
    return "";
  }
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);
  // return `${year}-${month}-${day}`;
  return `${hours}:${minutes}:${seconds}`;
};
